"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _reactredux = require('react-redux');



var _features = require('shared/selectors/org/features');
var _common = require('shared/selectors/org/common');
var _relations = require('shared/selectors/user/relations');
var _session = require('shared/selectors/session');
var _hooks = require('web/services/hooks');

/* Whether Forms opens for an org: 'loading' until the org is in the store,
 * 'not-member' for an org you aren't in, 'off' without its FORMS feature. */


 const formsGate = (state, orgKey) => {
  const rels = _relations.selectMyActiveRelationshipsList.call(void 0, state)
  if (!rels.length) return 'loading'
  if (!orgKey) return 'off'
  if (!rels.some(r => r.OrgKey === orgKey)) return 'not-member'
  if (!_common.selectOrgV1.call(void 0, state, orgKey )) return 'loading'
  return _features.selectOrgHasForms.call(void 0, state, orgKey ) ? 'on' : 'off'
}; exports.formsGate = formsGate

 const useFormsGate = (orgKey) => _hooks.useAppSelector.call(void 0, state => exports.formsGate.call(void 0, state, orgKey)); exports.useFormsGate = useFormsGate

/* Any of your orgs has Forms (a staff form link names no org, and My Inbox
 * selects none). */
 const useAnyOrgHasForms = () => _hooks.useAppSelector.call(void 0, state => {
  const rels = _relations.selectMyActiveRelationshipsList.call(void 0, state)
  if (!rels.length) return 'loading'
  return rels.some(r => exports.formsGate.call(void 0, state, r.OrgKey) === 'on') ? 'on' : 'off'
}); exports.useAnyOrgHasForms = useAnyOrgHasForms

/* Your approved orgs with Forms, by name. */
 const useFormsOrgKeys = () => _hooks.useAppSelector.call(void 0, 
  state => _relations.selectMyActiveRelationshipsList.call(void 0, state)
    .filter(r => exports.formsGate.call(void 0, state, r.OrgKey) === 'on')
    .map(r => r.OrgKey),
  _reactredux.shallowEqual,
); exports.useFormsOrgKeys = useFormsOrgKeys

/* Whether Forms shows: for the org you picked, its own FORMS feature; with
 * none picked (My Inbox), any of your orgs with Forms. */
 const useFormsShown = () => _hooks.useAppSelector.call(void 0, state => {
  const picked = _session.selectExplicitlySelectedOrgKey.call(void 0, state)
  if (picked) return exports.formsGate.call(void 0, state, picked)
  const rels = _relations.selectMyActiveRelationshipsList.call(void 0, state)
  if (!rels.length) return 'loading'
  return rels.some(r => exports.formsGate.call(void 0, state, r.OrgKey) === 'on') ? 'on' : 'off'
}); exports.useFormsShown = useFormsShown
